import collectionsConfig from './collections.config';

const {
  home,
  broadcastToday,
  opinionpanel,
  participationOverview,
  broadcastOverview,
  globalConfig,
} = collectionsConfig;

export interface IPagesConfig {
  fields: Array<string | object>;
}

const pagesConfig: { [key: string]: IPagesConfig } = {
  home: {
    fields: home,
  },

  broadcast_today: {
    fields: broadcastToday,
  },

  opinionpanel: {
    fields: opinionpanel,
  },

  participation_overview: {
    fields: participationOverview,
  },

  broadcast_overview: {
    fields: broadcastOverview,
  },

  global_config: {
    fields: globalConfig,
  },
};

export default pagesConfig;
